import adminAxios from "@/shared/api/adminAxiosInstance"

export const createSertificateLink = (price, description, customerEmail) => {
    return adminAxios.post('/admin/yookassa/create', {price, description, customerEmail})
}